export const NOM_APP = 'MaMarotte'

/** Titre de l'onglet : « MaMarotte - Page », ou « MaMarotte » seul sans page. */
export function titreOnglet(page?: string): string {
  return page ? `${NOM_APP} - ${page}` : NOM_APP
}
